import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useCustomerAuthStore from '../../states/customerAuth';

function ProtectedCustomerRoute({ children }) {
    const location = useLocation();
    const authenticated = useCustomerAuthStore((state) => state.authenticated);
    const initialized = useCustomerAuthStore((state) => state.initialized);
    const checking = useCustomerAuthStore((state) => state.checking);
    const checkSession = useCustomerAuthStore((state) => state.checkSession);

    React.useEffect(() => {
        if (!initialized && !checking) {
            checkSession();
        }
    }, [checkSession, checking, initialized]);

    if (!initialized || checking) {
        return <p>Checking session...</p>;
    }

    if (!authenticated) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    return children;
}

export default ProtectedCustomerRoute;